import First from '../../assets/nitk.jpg'
import Second from '../../assets/eee_dept.jpg'
import Third from '../../assets/MB.jpg'
import Fourth from '../../assets/beach.jpg'
import Fifth from '../../assets/lhc.jpeg'
import Sixth from '../../assets/fd.webp'

export default [{
  title:'First Slider Image',
  description: 'This is the First slider image',
  urls:First
},
{
  title:'Second Slider Image',
  description: 'This is the Second slider image',
  urls:Second
},
{
  title:'Third Slider Image',
  description: 'This is the Third slider image',
  urls:Third
},
{
  title:'Fourth Slider Image',
  description: 'This is the Fourth slider image',
  urls:Fourth
},

{
  title:'Fifth Slider Image',
  description: 'This is the Fourth slider image',
  urls:Fifth
},

{
  title:'Sixth Slider Image',
  description: 'This is the Fourth slider image',
  urls:Sixth
},
]